import { getCustomDataPresetVsme } from '../custom/data_preset_vsme';

export function getCustomDataPreset(entity: string, item: any, data: any, filter?: any): any {
    let preset: any = {};
    data = data || {};
    item = item || {};
    preset = getCustomDataPresetVsme(entity, item, data, filter) || {};
    
    return preset;
}
